import React from 'react';

import { CarouselSlider, CarouselSliderItem, CarouselTabPanel } from '@lux/carousel';
import { ErrorBoundary, ArticleCompactCard } from '@browsing/components';
import { NavigationSourceType, QueryParameters } from '@browsing/utils';

import { FashionPreferencesGenderValues } from '@browsing/filters';
import { ContinueShoppingCategory, ContinueShoppingCardItem } from '../types';
import { SeeAllCard } from './see-all-card';

interface CategoryPanelProps {
    category: ContinueShoppingCategory;
    categoriesList: ContinueShoppingCardItem[];
    shouldShowSeeAll: boolean;
    getOnArticleClick: (
        article: ContinueShoppingCardItem,
        index: number,
    ) => (e: React.SyntheticEvent) => void;
    getArticleURLPath: (article: ContinueShoppingCardItem, index: number) => string;
    onSeeAllClick: (
        categoryId: number,
        selectedFashionPreference?: FashionPreferencesGenderValues | 'NO_PREFERENCE',
    ) => void;
}

export const CategoryPanel: React.FC<CategoryPanelProps> = ({
    category,
    categoriesList,
    shouldShowSeeAll,
    getOnArticleClick,
    getArticleURLPath,
    onSeeAllClick,
}) => {
    return (
        <ErrorBoundary componentName={`continue-shopping-category-${category.categoryId}`}>
            <CarouselTabPanel id={category.categoryId.toString()}>
                <CarouselSlider>
                    {categoriesList.map((article, index) => (
                        <CarouselSliderItem key={article.sku}>
                            <div className="block max-w-full text-ellipsis whitespace-nowrap">
                                <ArticleCompactCard
                                    {...article}
                                    onClick={getOnArticleClick(article, index)}
                                    pdpURLPath={getArticleURLPath(article, index)}
                                />
                            </div>
                        </CarouselSliderItem>
                    ))}
                    {shouldShowSeeAll && (
                        <CarouselSliderItem key="continue-shopping-see-all">
                            <SeeAllCard
                                href={`/articles/categories/${category.categoryId}?${QueryParameters.NavigationSource}=${NavigationSourceType.ContinueShopping}`}
                                onClick={() =>
                                    onSeeAllClick(
                                        category.categoryId,
                                        category.selectedFashionPreference,
                                    )
                                }
                            />
                        </CarouselSliderItem>
                    )}
                </CarouselSlider>
            </CarouselTabPanel>
        </ErrorBoundary>
    );
};
